import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/management/stack.svg'
import _imports_2 from '@/assets/img/management/add.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-7daf5664")

_pushScopeId("data-v-7daf5664")
const _hoisted_1 = { class: "reservation_calendar hasAdminButtonsFooter" }
const _hoisted_2 = { class: "datesSlider" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_20 text-uppercase" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  style: {"transform":"rotate(180deg)"},
  src: _imports_0
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "round" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = { class: "adminButtonContainer" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_calendar = _resolveComponent("calendar", true)!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeMonth(true)))
      }, [
        _hoisted_3
      ]),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$filters.date(_ctx.selectedMonth, "MMMM YYYY")), 1),
      _createVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeMonth(false)))
      }, [
        _hoisted_5
      ])
    ]),
    _createVNode(_component_calendar, {
      modelValue: _ctx.selectedMonth,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedMonth = $event)),
      onDayClicked: _ctx.dayClicked
    }, null, 8, ["modelValue", "onDayClicked"]),
    _createVNode(_component_router_link, {
      class: "toggleContainer fixedLeftBottom rightActive",
      replace: true,
      to: { name: 'community_events' }
    }, {
      default: _withId(() => [
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_8, [
      (_ctx.$store.state.community.canContent)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "managementButton",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.newEvent()))
          }, [
            _hoisted_9
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})